import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { LoginService } from './login.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const loginService: LoginService = inject(LoginService);

    return next(req).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                loginService.logout();
                loginService.redirectToOauth();
            }
            return throwError(() => error);
        })
    );
};
